<template>
  <l-map ref="map" :zoom="zoom" :bounds.sync="lbounds" class="map-view">
    <l-tile-layer
      :url="layer.url"
      :attribution="showAttribution ? layer.attribution : ''"
      :accesskey="accessToken"
    />
    <l-polyline :latLngs="lpath" color="blue" :weight="2" :fill="false" />
    <l-marker v-if="currentLocation !== undefined" :latLng="currentLocation" :icon="myMarkerIcon" />
  </l-map>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPolyline } from 'vue2-leaflet';
import { easyButton } from 'leaflet-easybutton';
import { lml } from '@/library/mapping/LMap';
import PolylineDecoder from '@/library/PolylineDecoder';
import geometry from '@/library/Geometry';
import eventBus from '@/events/eventBus';
import logger from '@/domain/ClientLogger';

let lMap = null;

export default {
  name: 'l-map-view',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
  },
  props: {
    showAttribution: {
      type: Boolean,
      required: false,
      default: false,
    },
    polyline: {
      type: [Array, String],
      required: false,
      default: null,
    },
    bounds: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => ({
    zoom: 13,
    layer: lml.esriWorldTopo,
    attr: '',
    accessToken: 'pk.eyJ1IjoiYW5keTdyIiwiYSI6ImNqczk2c3p0MjB2MzA0M28xNTBhenQyMnQifQ.quQOJXvrMB2wUMLhOgDL3A',
    lbounds: [
      [54, 0],
      [53, 1],
    ],
    path: [],
    currentLocation: undefined,
  }),
  computed: {
    lpath() {
      return this.path && this.path.length > 1 ? this.path.map((p) => [p.lat, p.lng]) : [];
    },
    attribution() {
      return this.attr;
    },
    center() {
      return L.latLng(53.0, -1.0);
    },
  },
  watch: {
    polyline: {
      immediate: true,
      handler() {
        this.setPath();
      }
    },
    async bounds() {
      if (this.bounds) {
        this.fitToBounds(this.bounds);
      }
    },
  },
  mounted() {
    this.myMarkerIcon = L.icon({
      iconUrl: require('leaflet/dist/images/marker-icon.png')
    });
    this.$getLocation({ enableHighAccuracy: true })
      .then(coords => {
        console.log('got location');
        this.currentLocation = L.latLng(coords.lat, coords.lng);
      });
    // this.$watchLocation({ enableHighAccuracy: true })
    //   .then(coords => {
    //     console.log('watched location');
    //     if (coords) {
    //       this.currentLocation = L.latLng(coords.lat, coords.lng);
    //     }
    //   });
    logger.log(`LMap.mounted()`);
    this.$nextTick(() => {
      if (this.$refs.map) {
        this.initMap(this.$refs.map.mapObject);
        this.setPath();
      }
    });
  },
  methods: {
    initMap(map) {
      lMap = map;
      const layers = lml.getTileLayers();
      L.control.layers(layers).addTo(map);
      this.addButton('my_location', 'Zoom to activity', () => this.setPath());
    },
    addButton(icon, text, action) {
      if (lMap) {
        // tslint:disable-next-line: only-arrow-functions
        L.easyButton(`<i class="material-icons map-button">${icon}</i>`, function (btn, map) {
          action();
        }.bind(this), text).addTo(lMap);
      }
    },
    async fitPath() {
      if (this.path.length === 1) {
        logger.log(`LMap.fitPath() [centre]`);
        this.centre = this.path[0];
      } else if (this.path.length > 1) {
        const b = geometry.bounds(this.path);
        this.fitToBounds(b);
        logger.log(`LMap.fitPath() [bounds] ${b}`);
      }
    },
    async fitToBounds(bounds) {
      this.lbounds = [[bounds.sw.lat, bounds.sw.lng], [bounds.ne.lat, bounds.ne.lng]];
    },
    async setPath() {
      if (Array.isArray(this.polyline)) {
        this.path = this.polyline;
      } else if (this.polyline) {
        const d = new PolylineDecoder();
        this.path = d.decode(this.polyline);
      }
      if (this.path) {
        logger.log(`LMap.setPath() path ${this.path.length} x coords`);
        this.fitPath();
      }
    },
  },
};
</script>

<style lang="scss">
.map-view {
  div {
    &.leaflet-pane {
      &.leaflet-marker-pane {
        transform: translate(-12px, -40px);
      }
    }
  }
}
</style>
